module.exports = __webpack_public_path__ + "img/nian_the_cuddle_beast.64f9556d.png";